export * from './formatters';

/**
 * Default working month for a plan year: future years start at January,
 * the current (or a past) year starts at the current calendar month.
 */
export function defaultMonthForYear(year: number): number {
  const now = new Date();
  return year > now.getFullYear() ? 1 : now.getMonth() + 1;
}
